import React from "react";
import { ToastContainer } from "react-toastify";
import AddTagCollection from "../../components/ProductManager/TagCollection/AddTagCollection";

export const AddTagCollectionPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddTagCollection />
        </div>
      </div>
    </div>
  );
};
